import React from 'react';
import { Text, View } from 'react-native';

export default class TextForRef extends React.Component 
 {

   UpdateText(sText)
   {
   if (this.state.text != sText)
      this.setState({text: sText});
   }
   
    constructor(props)
    {
    super(props);

    this.state       = {text: props.text};
    this.UpdateText  = this.UpdateText.bind(this);
    }


   render() 
   {
   return (
      <Text style={this.props.style}> {this.state.text} </Text>
   );
   }
}